<template>
  <modal
    name="modal--confirm"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="350"
    :height="'auto'"
    @before-open="beforeOpen"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="w-full">
        <div
          class="text-center text-3xl sm:text-4xl mb-1 font-extralight tracking-tight"
        >
          {{ title }}
        </div>
        <div class="text-center text-lg mb-6 font-extralight tracking-tight">
          {{ text }}
        </div>

        <div class="flex flex-row justify-between mt-3">
          <s-button
            v-for="(button, index) in modalButtons"
            :key="index"
            class="shadow-lg"
            :class="button.class"
            @click="handleClick(button)"
          >
            {{ button.title }}
          </s-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import SButton from '@/components/Button'

export default {
  name: 'ModalConfirm',
  components: {
    SButton
  },
  data() {
    return {
      title: '',
      text: '',
      modalButtons: []
    }
  },
  methods: {
    beforeOpen(event) {
      // Set modal content from params
      this.title = event.params.title || 'Confirm'
      this.text = event.params.text || 'Are you sure?'
      this.modalButtons = event.params.buttons || [
        {
          title: 'Cancel',
          handler: () => this.$modal.hide('modal--confirm')
        }
      ]
    },
    handleClick(button) {
      if (button.handler) {
        button.handler()
      } else {
        this.$modal.hide('modal--confirm')
      }
    }
  }
}
</script>
